import React from "react";
import "./hotel-loader.css";

const HotelLoader = () => (
  <div className="hotel-loading">
    <i className="fa fa-bed"></i>
    <i className="fa fa-key"></i>
    <i className="fa fa-suitcase"></i>
    <i className="fa fa-globe"></i>
    <i className="fa fa-umbrella-beach"></i>
  </div>
);

export default HotelLoader;